/**
 * Tipo de transacciones de puntos
 */
export enum LoyaltyTransactionType {
  EARN   = 'earn',   // acumulación por compra
  REDEEM = 'redeem', // canje por recompensa
  MANUAL = 'manual', // ajuste manual del admin
}

/**
 * Configuración del programa de lealtad en una organización
 */
export interface LoyaltyProgram {
  isEnabled: boolean;
  isPaused: boolean;
  programName: string;         // ej: "KornCoins"
  pointsPerAmount: number;     // monto en C$ para ganar 1 punto
  createdAt: number;
  updatedAt: number;
}

/**
 * Cuenta de fidelización de un cliente específico en una organización específica
 * path: loyalty_accounts/{orgId}_{uid}
 */
export interface LoyaltyAccount {
  id: string;              // {orgId}_{uid}
  orgId: string;
  uid: string;             // Firebase Auth UID
  phoneNumber: string;     // E.164
  currentPoints: number;   // puntos disponibles
  totalEarned: number;
  totalRedeemed: number;
  joinedAt: number;
  updatedAt: number;
}

/**
 * Registro de una transacción de puntos
 * path: loyalty_accounts/{accountId}/transactions/{txId}
 */
export interface LoyaltyTransaction {
  id: string;
  type: LoyaltyTransactionType;
  points: number;
  
  // Trazabilidad
  branchId: string;
  createdBy?: string;      // uid del admin si fue MANUAL o REDEEM
  
  // Solo tipo EARN
  orderId?: string;
  orderSubtotal?: number;

  // Solo tipo REDEEM
  contentId?: string;      // ID del item del catálogo canjeado
  rewardName?: string;     // snapshot del nombre
  rewardType?: 'item' | 'discount_pct' | 'discount_fixed';

  reference: string;

  createdAt: number;
}

/**
 * Sesión temporal para el flujo de canje por QR
 * path: redemptionSessions/{sessionId}
 */
export interface RedemptionSession {
  id: string;
  orgId: string;
  branchId: string;
  uid: string;             // UID del cliente que va a canjear
  contentId: string;       // Recompensa seleccionada
  status: 'pending' | 'authorized' | 'completed' | 'expired';
  expiresAt: number;
  createdAt: number;
}
